import { render } from "./eliteProspectsPlayerDataComponent.vue?vue&type=template&id=7835fe90"
import script from "./eliteProspectsPlayerDataComponent.vue?vue&type=script&lang=js"
export * from "./eliteProspectsPlayerDataComponent.vue?vue&type=script&lang=js"

import "./eliteProspectsPlayerDataComponent.vue?vue&type=style&index=0&id=7835fe90&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__